import QueryClientProvider from '../query-client-provider'
import SecitonActivation from './section'

export default function AccountActivation() {
  return (
    <QueryClientProvider>
      <SecitonActivation />
    </QueryClientProvider>
  )
}
